// extracted by mini-css-extract-plugin
export default {"component":"TargetsLayout_component__UrxlM","filter":"TargetsLayout_filter__Y6rOU","title":"TargetsLayout_title__2yxNN"};